import VideoContainer from '@components/common/VideoPlayer/VideoContainer'

interface YoutubePlayerProps {
	liveLinkUrl?: string
	autoPlayStatus?: string
}
const YoutubePlayer = ({ liveLinkUrl, autoPlayStatus }: YoutubePlayerProps) => {
	const hasParams = liveLinkUrl?.includes('?')
	return (
		liveLinkUrl &&
		autoPlayStatus && (
			<VideoContainer ratio="1.767" isIframe>
				<iframe
					className="video-container-iframe"
					width="560"
					height="315"
					src={`${liveLinkUrl}${hasParams ? '&' : '?'}${autoPlayStatus}&mute=1&rel=0`}
					title="YouTube video player"
					frameBorder={0}
					allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
					allowFullScreen
				/>
			</VideoContainer>
		)
	)
}
export default YoutubePlayer
